import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { QueryResult } from "../../query-runner/QueryResult";
import { TransactionNotStartedError } from "../../error/TransactionNotStartedError";
import { TableColumn } from "../../schema-builder/table/TableColumn";
import { Table } from "../../schema-builder/table/Table";
import { TableForeignKey } from "../../schema-builder/table/TableForeignKey";
import { TableIndex } from "../../schema-builder/table/TableIndex";
import { QueryRunnerAlreadyReleasedError } from "../../error/QueryRunnerAlreadyReleasedError";
import { View } from "../../schema-builder/view/View";
import { Query } from "../Query";
import { OrmUtils } from "../../util/OrmUtils";
import { TableUnique } from "../../schema-builder/table/TableUnique";
import { BaseQueryRunner } from "../../query-runner/BaseQueryRunner";
import { Broadcaster } from "../../subscriber/Broadcaster";
import { TypeORMError } from "../../error";
import { MetadataTableType } from "../types/MetadataTableType";
import { InstanceChecker } from "../../util/InstanceChecker";
/**
 * Runs queries on a single mysql database connection.
 */
export var AuroraMysqlQueryRunner = /*#__PURE__*/function (_BaseQueryRunner) {
  _inherits(AuroraMysqlQueryRunner, _BaseQueryRunner);
  var _super = _createSuper(AuroraMysqlQueryRunner);
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function AuroraMysqlQueryRunner(driver, client) {
    var _this;
    _classCallCheck(this, AuroraMysqlQueryRunner);
    _this = _super.call(this);
    _this.driver = driver;
    _this.connection = driver.connection;
    _this.client = client;
    _this.broadcaster = new Broadcaster(_assertThisInitialized(_this));
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates/uses database connection from the connection pool to perform further operations.
   * Returns obtained database connection.
   */
  _createClass(AuroraMysqlQueryRunner, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {});
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Releases used database connection.
     * You cannot use query runner methods once its released.
     */
  }, {
    key: "release",
    value: function release() {
      this.isReleased = true;
      if (this.databaseConnection) this.databaseConnection.release();
      return Promise.resolve();
    }
    /**
     * Starts transaction on the current connection.
     */
  }, {
    key: "startTransaction",
    value: function () {
      var _startTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(isolationLevel) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.isTransactionActive = true;
              _context2.prev = 1;
              _context2.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionStart");
            case 4:
              _context2.next = 10;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              this.isTransactionActive = false;
              throw _context2.t0;
            case 10:
              if (!(this.transactionDepth === 0)) {
                _context2.next = 15;
                break;
              }
              _context2.next = 13;
              return this.client.startTransaction();
            case 13:
              _context2.next = 17;
              break;
            case 15:
              _context2.next = 17;
              return this.query("SAVEPOINT typeorm_".concat(this.transactionDepth));
            case 17:
              this.transactionDepth += 1;
              _context2.next = 20;
              return this.broadcaster.broadcast("AfterTransactionStart");
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function startTransaction(_x) {
        return _startTransaction.apply(this, arguments);
      }
      return startTransaction;
    }()
    /**
     * Commits transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "commitTransaction",
    value: function () {
      var _commitTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.isTransactionActive) {
                _context3.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context3.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionCommit");
            case 4:
              if (!(this.transactionDepth > 1)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return this.query("RELEASE SAVEPOINT typeorm_".concat(this.transactionDepth - 1));
            case 7:
              _context3.next = 12;
              break;
            case 9:
              _context3.next = 11;
              return this.client.commitTransaction();
            case 11:
              this.isTransactionActive = false;
            case 12:
              this.transactionDepth -= 1;
              _context3.next = 15;
              return this.broadcaster.broadcast("AfterTransactionCommit");
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function commitTransaction() {
        return _commitTransaction.apply(this, arguments);
      }
      return commitTransaction;
    }()
    /**
     * Rollbacks transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "rollbackTransaction",
    value: function () {
      var _rollbackTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.isTransactionActive) {
                _context4.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context4.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionRollback");
            case 4:
              if (!(this.transactionDepth > 1)) {
                _context4.next = 9;
                break;
              }
              _context4.next = 7;
              return this.query("ROLLBACK TO SAVEPOINT typeorm_".concat(this.transactionDepth - 1));
            case 7:
              _context4.next = 12;
              break;
            case 9:
              _context4.next = 11;
              return this.client.rollbackTransaction();
            case 11:
              this.isTransactionActive = false;
            case 12:
              this.transactionDepth -= 1;
              _context4.next = 15;
              return this.broadcaster.broadcast("AfterTransactionRollback");
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function rollbackTransaction() {
        return _rollbackTransaction.apply(this, arguments);
      }
      return rollbackTransaction;
    }()
    /**
     * Executes a raw SQL query.
     */
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_query, parameters) {
        var useStructuredResult,
          raw,
          result,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              useStructuredResult = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : false;
              if (!this.isReleased) {
                _context5.next = 3;
                break;
              }
              throw new QueryRunnerAlreadyReleasedError();
            case 3:
              _context5.next = 5;
              return this.client.query(_query, parameters);
            case 5:
              raw = _context5.sent;
              result = new QueryResult();
              result.raw = raw;
              if ((raw === null || raw === void 0 ? void 0 : raw.hasOwnProperty("records")) && Array.isArray(raw.records)) {
                result.records = raw.records;
              }
              if (raw === null || raw === void 0 ? void 0 : raw.hasOwnProperty("numberOfRecordsUpdated")) {
                result.affected = raw.numberOfRecordsUpdated;
              }
              if (useStructuredResult) {
                _context5.next = 12;
                break;
              }
              return _context5.abrupt("return", result.raw);
            case 12:
              return _context5.abrupt("return", result);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function query(_x2, _x3) {
        return _query2.apply(this, arguments);
      }
      return query;
    }()
    /**
     * Returns raw data stream.
     */
  }, {
    key: "stream",
    value: function stream(query, parameters, onEnd, onError) {
      var _this2 = this;
      if (this.isReleased) throw new QueryRunnerAlreadyReleasedError();
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(ok, fail) {
          var databaseConnection, stream;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this2.connect();
              case 3:
                databaseConnection = _context6.sent;
                stream = databaseConnection.query(query, parameters);
                if (onEnd) stream.on("end", onEnd);
                if (onError) stream.on("error", onError);
                ok(stream);
                _context6.next = 13;
                break;
              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);
                fail(_context6.t0);
              case 13:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[0, 10]]);
        }));
        return function (_x4, _x5) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * Returns all available database names including system databases.
     */
  }, {
    key: "getDatabases",
    value: function () {
      var _getDatabases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function getDatabases() {
        return _getDatabases.apply(this, arguments);
      }
      return getDatabases;
    }()
    /**
     * Returns all available schema names including system schemas.
     * If database parameter specified, returns schemas of that database.
     */
  }, {
    key: "getSchemas",
    value: function () {
      var _getSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(database) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              throw new TypeORMError("MySql driver does not support table schemas");
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function getSchemas(_x6) {
        return _getSchemas.apply(this, arguments);
      }
      return getSchemas;
    }()
    /**
     * Checks if database with the given name exist.
     */
  }, {
    key: "hasDatabase",
    value: function () {
      var _hasDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(database) {
        var result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.query("SELECT * FROM `INFORMATION_SCHEMA`.`SCHEMATA` WHERE `SCHEMA_NAME` = '".concat(database, "'"));
            case 2:
              result = _context9.sent;
              return _context9.abrupt("return", result.length ? true : false);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function hasDatabase(_x7) {
        return _hasDatabase.apply(this, arguments);
      }
      return hasDatabase;
    }()
    /**
     * Loads currently using database
     */
  }, {
    key: "getCurrentDatabase",
    value: function () {
      var _getCurrentDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var query;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.query("SELECT DATABASE() AS `db_name`");
            case 2:
              query = _context10.sent;
              return _context10.abrupt("return", query[0]["db_name"]);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getCurrentDatabase() {
        return _getCurrentDatabase.apply(this, arguments);
      }
      return getCurrentDatabase;
    }()
    /**
     * Checks if schema with the given name exist.
     */
  }, {
    key: "hasSchema",
    value: function () {
      var _hasSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(schema) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              throw new TypeORMError("MySql driver does not support table schemas");
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function hasSchema(_x8) {
        return _hasSchema.apply(this, arguments);
      }
      return hasSchema;
    }()
    /**
     * Loads currently using database schema
     */
  }, {
    key: "getCurrentSchema",
    value: function () {
      var _getCurrentSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var query;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.query("SELECT SCHEMA() AS `schema_name`");
            case 2:
              query = _context12.sent;
              return _context12.abrupt("return", query[0]["schema_name"]);
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getCurrentSchema() {
        return _getCurrentSchema.apply(this, arguments);
      }
      return getCurrentSchema;
    }()
    /**
     * Checks if table with the given name exist in the database.
     */
  }, {
    key: "hasTable",
    value: function () {
      var _hasTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(tableOrName) {
        var parsedTableName, sql, result;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              parsedTableName = this.driver.parseTableName(tableOrName);
              sql = "SELECT * FROM `INFORMATION_SCHEMA`.`COLUMNS` WHERE `TABLE_SCHEMA` = '".concat(parsedTableName.database, "' AND `TABLE_NAME` = '").concat(parsedTableName.tableName, "'");
              _context13.next = 4;
              return this.query(sql);
            case 4:
              result = _context13.sent;
              return _context13.abrupt("return", result.length ? true : false);
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function hasTable(_x9) {
        return _hasTable.apply(this, arguments);
      }
      return hasTable;
    }()
    /**
     * Checks if column with the given name exist in the given table.
     */
  }, {
    key: "hasColumn",
    value: function () {
      var _hasColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(tableOrName, column) {
        var parsedTableName, columnName, sql, result;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              parsedTableName = this.driver.parseTableName(tableOrName);
              columnName = InstanceChecker.isTableColumn(column) ? column.name : column;
              sql = "SELECT * FROM `INFORMATION_SCHEMA`.`COLUMNS` WHERE `TABLE_SCHEMA` = '".concat(parsedTableName.database, "' AND `TABLE_NAME` = '").concat(parsedTableName.tableName, "' AND `COLUMN_NAME` = '").concat(columnName, "'");
              _context14.next = 5;
              return this.query(sql);
            case 5:
              result = _context14.sent;
              return _context14.abrupt("return", result.length ? true : false);
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function hasColumn(_x10, _x11) {
        return _hasColumn.apply(this, arguments);
      }
      return hasColumn;
    }()
    /**
     * Creates a new database.
     */
  }, {
    key: "createDatabase",
    value: function () {
      var _createDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(database, ifNotExist) {
        var up, down;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              up = ifNotExist ? "CREATE DATABASE IF NOT EXISTS `".concat(database, "`") : "CREATE DATABASE `".concat(database, "`");
              down = "DROP DATABASE `".concat(database, "`");
              _context15.next = 4;
              return this.executeQueries(new Query(up), new Query(down));
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function createDatabase(_x12, _x13) {
        return _createDatabase.apply(this, arguments);
      }
      return createDatabase;
    }()
    /**
     * Drops database.
     */
  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(database, ifExist) {
        var up, down;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              up = ifExist ? "DROP DATABASE IF EXISTS `".concat(database, "`") : "DROP DATABASE `".concat(database, "`");
              down = "CREATE DATABASE `".concat(database, "`");
              _context16.next = 4;
              return this.executeQueries(new Query(up), new Query(down));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function dropDatabase(_x14, _x15) {
        return _dropDatabase.apply(this, arguments);
      }
      return dropDatabase;
    }()
    /**
     * Creates a new table schema.
     */
  }, {
    key: "createSchema",
    value: function () {
      var _createSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(schemaPath, ifNotExist) {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              throw new TypeORMError("Schema create queries are not supported by MySql driver.");
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function createSchema(_x16, _x17) {
        return _createSchema.apply(this, arguments);
      }
      return createSchema;
    }()
    /**
     * Drops table schema.
     */
  }, {
    key: "dropSchema",
    value: function () {
      var _dropSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(schemaPath, ifExist) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              throw new TypeORMError("Schema drop queries are not supported by MySql driver.");
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      function dropSchema(_x18, _x19) {
        return _dropSchema.apply(this, arguments);
      }
      return dropSchema;
    }()
    /**
     * Creates a new table.
     */
  }, {
    key: "createTable",
    value: function () {
      var _createTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(table) {
        var _this3 = this;
        var ifNotExist,
          createForeignKeys,
          isTableExist,
          upQueries,
          downQueries,
          _args19 = arguments;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              ifNotExist = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : false;
              createForeignKeys = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : true;
              if (!ifNotExist) {
                _context19.next = 8;
                break;
              }
              _context19.next = 5;
              return this.hasTable(table);
            case 5:
              isTableExist = _context19.sent;
              if (!isTableExist) {
                _context19.next = 8;
                break;
              }
              return _context19.abrupt("return", Promise.resolve());
            case 8:
              upQueries = [];
              downQueries = [];
              upQueries.push(this.createTableSql(table, createForeignKeys));
              downQueries.push(this.dropTableSql(table));
              // we must first drop indices, than drop foreign keys, because drop queries runs in reversed order
              // and foreign keys will be dropped first as indices. This order is very important, because we can't drop index
              // if it related to the foreign key.
              // createTable does not need separate method to create indices, because it create indices in the same query with table creation.
              table.indices.forEach(function (index) {
                return downQueries.push(_this3.dropIndexSql(table, index));
              });
              // if createForeignKeys is true, we must drop created foreign keys in down query.
              // createTable does not need separate method to create foreign keys, because it create fk's in the same query with table creation.
              if (createForeignKeys) table.foreignKeys.forEach(function (foreignKey) {
                return downQueries.push(_this3.dropForeignKeySql(table, foreignKey));
              });
              return _context19.abrupt("return", this.executeQueries(upQueries, downQueries));
            case 15:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function createTable(_x20) {
        return _createTable.apply(this, arguments);
      }
      return createTable;
    }()
    /**
     * Drop the table.
     */
  }, {
    key: "dropTable",
    value: function () {
      var _dropTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(target, ifExist) {
        var _this4 = this;
        var dropForeignKeys,
          isTableExist,
          createForeignKeys,
          tablePath,
          table,
          upQueries,
          downQueries,
          _args20 = arguments;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              dropForeignKeys = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : true;
              if (!ifExist) {
                _context20.next = 7;
                break;
              }
              _context20.next = 4;
              return this.hasTable(target);
            case 4:
              isTableExist = _context20.sent;
              if (isTableExist) {
                _context20.next = 7;
                break;
              }
              return _context20.abrupt("return", Promise.resolve());
            case 7:
              // if dropTable called with dropForeignKeys = true, we must create foreign keys in down query.
              createForeignKeys = dropForeignKeys;
              tablePath = this.getTablePath(target);
              _context20.next = 11;
              return this.getCachedTable(tablePath);
            case 11:
              table = _context20.sent;
              upQueries = [];
              downQueries = [];
              if (dropForeignKeys) table.foreignKeys.forEach(function (foreignKey) {
                return upQueries.push(_this4.dropForeignKeySql(table, foreignKey));
              });
              table.indices.forEach(function (index) {
                return upQueries.push(_this4.dropIndexSql(table, index));
              });
              upQueries.push(this.dropTableSql(table));
              downQueries.push(this.createTableSql(table, createForeignKeys));
              _context20.next = 20;
              return this.executeQueries(upQueries, downQueries);
            case 20:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function dropTable(_x21, _x22) {
        return _dropTable.apply(this, arguments);
      }
      return dropTable;
    }()
    /**
     * Creates a new view.
     */
  }, {
    key: "createView",
    value: function () {
      var _createView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(view) {
        var syncWithMetadata,
          upQueries,
          downQueries,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              syncWithMetadata = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : false;
              upQueries = [];
              downQueries = [];
              upQueries.push(this.createViewSql(view));
              if (!syncWithMetadata) {
                _context21.next = 10;
                break;
              }
              _context21.t0 = upQueries;
              _context21.next = 8;
              return this.insertViewDefinitionSql(view);
            case 8:
              _context21.t1 = _context21.sent;
              _context21.t0.push.call(_context21.t0, _context21.t1);
            case 10:
              downQueries.push(this.dropViewSql(view));
              if (!syncWithMetadata) {
                _context21.next = 17;
                break;
              }
              _context21.t2 = downQueries;
              _context21.next = 15;
              return this.deleteViewDefinitionSql(view);
            case 15:
              _context21.t3 = _context21.sent;
              _context21.t2.push.call(_context21.t2, _context21.t3);
            case 17:
              _context21.next = 19;
              return this.executeQueries(upQueries, downQueries);
            case 19:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function createView(_x23) {
        return _createView.apply(this, arguments);
      }
      return createView;
    }()
    /**
     * Drops the view.
     */
  }, {
    key: "dropView",
    value: function () {
      var _dropView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(target) {
        var viewName, view, upQueries, downQueries;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              viewName = InstanceChecker.isView(target) ? target.name : target;
              _context22.next = 3;
              return this.getCachedView(viewName);
            case 3:
              view = _context22.sent;
              upQueries = [];
              downQueries = [];
              _context22.t0 = upQueries;
              _context22.next = 9;
              return this.deleteViewDefinitionSql(view);
            case 9:
              _context22.t1 = _context22.sent;
              _context22.t0.push.call(_context22.t0, _context22.t1);
              upQueries.push(this.dropViewSql(view));
              _context22.t2 = downQueries;
              _context22.next = 15;
              return this.insertViewDefinitionSql(view);
            case 15:
              _context22.t3 = _context22.sent;
              _context22.t2.push.call(_context22.t2, _context22.t3);
              downQueries.push(this.createViewSql(view));
              _context22.next = 20;
              return this.executeQueries(upQueries, downQueries);
            case 20:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function dropView(_x24) {
        return _dropView.apply(this, arguments);
      }
      return dropView;
    }()
    /**
     * Renames a table.
     */
  }, {
    key: "renameTable",
    value: function () {
      var _renameTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(oldTableOrName, newTableName) {
        var _this5 = this;
        var upQueries, downQueries, oldTable, newTable, _this$driver$parseTab, database;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              upQueries = [];
              downQueries = [];
              if (!InstanceChecker.isTable(oldTableOrName)) {
                _context23.next = 6;
                break;
              }
              _context23.t0 = oldTableOrName;
              _context23.next = 9;
              break;
            case 6:
              _context23.next = 8;
              return this.getCachedTable(oldTableOrName);
            case 8:
              _context23.t0 = _context23.sent;
            case 9:
              oldTable = _context23.t0;
              newTable = oldTable.clone();
              _this$driver$parseTab = this.driver.parseTableName(oldTable), database = _this$driver$parseTab.database;
              newTable.name = database ? "".concat(database, ".").concat(newTableName) : newTableName;
              // rename table
              upQueries.push(new Query("RENAME TABLE ".concat(this.escapePath(oldTable), " TO ").concat(this.escapePath(newTable))));
              downQueries.push(new Query("RENAME TABLE ".concat(this.escapePath(newTable), " TO ").concat(this.escapePath(oldTable))));
              // rename index constraints
              newTable.indices.forEach(function (index) {
                // build new constraint name
                var columnNames = index.columnNames.map(function (column) {
                  return "`".concat(column, "`");
                }).join(", ");
                var newIndexName = _this5.connection.namingStrategy.indexName(newTable, index.columnNames, index.where);
                // build queries
                var indexType = "";
                if (index.isUnique) indexType += "UNIQUE ";
                if (index.isSpatial) indexType += "SPATIAL ";
                if (index.isFulltext) indexType += "FULLTEXT ";
                upQueries.push(new Query("ALTER TABLE ".concat(_this5.escapePath(newTable), " DROP INDEX `").concat(index.name, "`, ADD ").concat(indexType, "INDEX `").concat(newIndexName, "` (").concat(columnNames, ")")));
                downQueries.push(new Query("ALTER TABLE ".concat(_this5.escapePath(newTable), " DROP INDEX `").concat(newIndexName, "`, ADD ").concat(indexType, "INDEX `").concat(index.name, "` (").concat(columnNames, ")")));
                // replace constraint name
                index.name = newIndexName;
              });
              // rename foreign key constraint
              newTable.foreignKeys.forEach(function (foreignKey) {
                // build new constraint name
                var columnNames = foreignKey.columnNames.map(function (column) {
                  return "`".concat(column, "`");
                }).join(", ");
                var referencedColumnNames = foreignKey.referencedColumnNames.map(function (column) {
                  return "`".concat(column, "`");
                }).join(",");
                var newForeignKeyName = _this5.connection.namingStrategy.foreignKeyName(newTable, foreignKey.columnNames);
                // build queries
                var up = "ALTER TABLE ".concat(_this5.escapePath(newTable), " DROP FOREIGN KEY `").concat(foreignKey.name, "`, ADD CONSTRAINT `").concat(newForeignKeyName, "` FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(_this5.escapePath(_this5.getTablePath(foreignKey)), "(").concat(referencedColumnNames, ")");
                if (foreignKey.onDelete) up += " ON DELETE ".concat(foreignKey.onDelete);
                if (foreignKey.onUpdate) up += " ON UPDATE ".concat(foreignKey.onUpdate);
                var down = "ALTER TABLE ".concat(_this5.escapePath(newTable), " DROP FOREIGN KEY `").concat(newForeignKeyName, "`, ADD CONSTRAINT `").concat(foreignKey.name, "` FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(_this5.escapePath(_this5.getTablePath(foreignKey)), "(").concat(referencedColumnNames, ")");
                if (foreignKey.onDelete) down += " ON DELETE ".concat(foreignKey.onDelete);
                if (foreignKey.onUpdate) down += " ON UPDATE ".concat(foreignKey.onUpdate);
                upQueries.push(new Query(up));
                downQueries.push(new Query(down));
                // replace constraint name
                foreignKey.name = newForeignKeyName;
              });
              _context23.next = 19;
              return this.executeQueries(upQueries, downQueries);
            case 19:
              // rename old table and replace it in cached tabled;
              oldTable.name = newTable.name;
              this.replaceCachedTable(oldTable, newTable);
            case 21:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function renameTable(_x25, _x26) {
        return _renameTable.apply(this, arguments);
      }
      return renameTable;
    }()
    /**
     * Creates a new column from the column in the table.
     */
  }, {
    key: "addColumn",
    value: function () {
      var _addColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(tableOrName, column) {
        var table, clonedTable, upQueries, downQueries, skipColumnLevelPrimary, generatedColumn, nonGeneratedColumn, primaryColumns, columnNames, _nonGeneratedColumn, columnIndex, uniqueIndex;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context24.next = 4;
                break;
              }
              _context24.t0 = tableOrName;
              _context24.next = 7;
              break;
            case 4:
              _context24.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context24.t0 = _context24.sent;
            case 7:
              table = _context24.t0;
              clonedTable = table.clone();
              upQueries = [];
              downQueries = [];
              skipColumnLevelPrimary = clonedTable.primaryColumns.length > 0;
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(column, skipColumnLevelPrimary, false))));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN `").concat(column.name, "`")));
              // create or update primary key constraint
              if (column.isPrimary && skipColumnLevelPrimary) {
                // if we already have generated column, we must temporary drop AUTO_INCREMENT property.
                generatedColumn = clonedTable.columns.find(function (column) {
                  return column.isGenerated && column.generationStrategy === "increment";
                });
                if (generatedColumn) {
                  nonGeneratedColumn = generatedColumn.clone();
                  nonGeneratedColumn.isGenerated = false;
                  nonGeneratedColumn.generationStrategy = undefined;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(column.name, "` ").concat(this.buildCreateColumnSql(nonGeneratedColumn, true))));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(nonGeneratedColumn.name, "` ").concat(this.buildCreateColumnSql(column, true))));
                }
                primaryColumns = clonedTable.primaryColumns;
                columnNames = primaryColumns.map(function (column) {
                  return "`".concat(column.name, "`");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(columnNames, ")")));
                primaryColumns.push(column);
                columnNames = primaryColumns.map(function (column) {
                  return "`".concat(column.name, "`");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(columnNames, ")")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
                // if we previously dropped AUTO_INCREMENT property, we must bring it back
                if (generatedColumn) {
                  _nonGeneratedColumn = generatedColumn.clone();
                  _nonGeneratedColumn.isGenerated = false;
                  _nonGeneratedColumn.generationStrategy = undefined;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(_nonGeneratedColumn.name, "` ").concat(this.buildCreateColumnSql(column, true))));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(column.name, "` ").concat(this.buildCreateColumnSql(_nonGeneratedColumn, true))));
                }
              }
              // create column index
              columnIndex = clonedTable.indices.find(function (index) {
                return index.columnNames.length === 1 && index.columnNames[0] === column.name;
              });
              if (columnIndex) {
                upQueries.push(this.createIndexSql(table, columnIndex));
                downQueries.push(this.dropIndexSql(table, columnIndex));
              } else if (column.isUnique) {
                uniqueIndex = new TableIndex({
                  name: this.connection.namingStrategy.indexName(table, [column.name]),
                  columnNames: [column.name],
                  isUnique: true
                });
                clonedTable.indices.push(uniqueIndex);
                clonedTable.uniques.push(new TableUnique({
                  name: uniqueIndex.name,
                  columnNames: uniqueIndex.columnNames
                }));
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD UNIQUE INDEX `").concat(uniqueIndex.name, "` (`").concat(column.name, "`)")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP INDEX `").concat(uniqueIndex.name, "`")));
              }
              _context24.next = 19;
              return this.executeQueries(upQueries, downQueries);
            case 19:
              clonedTable.addColumn(column);
              this.replaceCachedTable(table, clonedTable);
            case 21:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function addColumn(_x27, _x28) {
        return _addColumn.apply(this, arguments);
      }
      return addColumn;
    }()
    /**
     * Creates a new columns from the column in the table.
     */
  }, {
    key: "addColumns",
    value: function () {
      var _addColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(tableOrName, columns) {
        var _iterator, _step, column;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(columns);
              _context25.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context25.next = 9;
                break;
              }
              column = _step.value;
              _context25.next = 7;
              return this.addColumn(tableOrName, column);
            case 7:
              _context25.next = 3;
              break;
            case 9:
              _context25.next = 14;
              break;
            case 11:
              _context25.prev = 11;
              _context25.t0 = _context25["catch"](1);
              _iterator.e(_context25.t0);
            case 14:
              _context25.prev = 14;
              _iterator.f();
              return _context25.finish(14);
            case 17:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this, [[1, 11, 14, 17]]);
      }));
      function addColumns(_x29, _x30) {
        return _addColumns.apply(this, arguments);
      }
      return addColumns;
    }()
    /**
     * Renames column in the given table.
     */
  }, {
    key: "renameColumn",
    value: function () {
      var _renameColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(tableOrName, oldTableColumnOrName, newTableColumnOrName) {
        var table, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context26.next = 4;
                break;
              }
              _context26.t0 = tableOrName;
              _context26.next = 7;
              break;
            case 4:
              _context26.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context26.t0 = _context26.sent;
            case 7:
              table = _context26.t0;
              oldColumn = InstanceChecker.isTableColumn(oldTableColumnOrName) ? oldTableColumnOrName : table.columns.find(function (c) {
                return c.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context26.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 11:
              newColumn = undefined;
              if (InstanceChecker.isTableColumn(newTableColumnOrName)) {
                newColumn = newTableColumnOrName;
              } else {
                newColumn = oldColumn.clone();
                newColumn.name = newTableColumnOrName;
              }
              _context26.next = 15;
              return this.changeColumn(table, oldColumn, newColumn);
            case 15:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function renameColumn(_x31, _x32, _x33) {
        return _renameColumn.apply(this, arguments);
      }
      return renameColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumn",
    value: function () {
      var _changeColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(tableOrName, oldColumnOrName, newColumn) {
        var _this6 = this;
        var table, clonedTable, upQueries, downQueries, oldColumn, oldTableColumn, generatedColumn, nonGeneratedColumn, primaryColumns, columnNames, column, _columnNames, primaryColumn, _column, _columnNames2, _nonGeneratedColumn2, uniqueIndex, _uniqueIndex, tableUnique;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context27.next = 4;
                break;
              }
              _context27.t0 = tableOrName;
              _context27.next = 7;
              break;
            case 4:
              _context27.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context27.t0 = _context27.sent;
            case 7:
              table = _context27.t0;
              clonedTable = table.clone();
              upQueries = [];
              downQueries = [];
              oldColumn = InstanceChecker.isTableColumn(oldColumnOrName) ? oldColumnOrName : table.columns.find(function (column) {
                return column.name === oldColumnOrName;
              });
              if (oldColumn) {
                _context27.next = 14;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 14:
              if (!(newColumn.isGenerated !== oldColumn.isGenerated && newColumn.generationStrategy !== "uuid" || oldColumn.type !== newColumn.type || oldColumn.length !== newColumn.length || oldColumn.generatedType !== newColumn.generatedType)) {
                _context27.next = 22;
                break;
              }
              _context27.next = 17;
              return this.dropColumn(table, oldColumn);
            case 17:
              _context27.next = 19;
              return this.addColumn(table, newColumn);
            case 19:
              // update cloned table
              clonedTable = table.clone();
              _context27.next = 26;
              break;
            case 22:
              if (newColumn.name !== oldColumn.name) {
                // We don't change any column properties, just rename it.
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(oldColumn.name, "` `").concat(newColumn.name, "` ").concat(this.buildCreateColumnSql(oldColumn, true, true))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(newColumn.name, "` `").concat(oldColumn.name, "` ").concat(this.buildCreateColumnSql(oldColumn, true, true))));
                // rename index constraints
                clonedTable.findColumnIndices(oldColumn).forEach(function (index) {
                  // build new constraint name
                  index.columnNames.splice(index.columnNames.indexOf(oldColumn.name), 1);
                  index.columnNames.push(newColumn.name);
                  var columnNames = index.columnNames.map(function (column) {
                    return "`".concat(column, "`");
                  }).join(", ");
                  var newIndexName = _this6.connection.namingStrategy.indexName(clonedTable, index.columnNames, index.where);
                  // build queries
                  var indexType = "";
                  if (index.isUnique) indexType += "UNIQUE ";
                  if (index.isSpatial) indexType += "SPATIAL ";
                  if (index.isFulltext) indexType += "FULLTEXT ";
                  upQueries.push(new Query("ALTER TABLE ".concat(_this6.escapePath(table), " DROP INDEX `").concat(index.name, "`, ADD ").concat(indexType, "INDEX `").concat(newIndexName, "` (").concat(columnNames, ")")));
                  downQueries.push(new Query("ALTER TABLE ".concat(_this6.escapePath(table), " DROP INDEX `").concat(newIndexName, "`, ADD ").concat(indexType, "INDEX `").concat(index.name, "` (").concat(columnNames, ")")));
                  // replace constraint name
                  index.name = newIndexName;
                });
                // rename foreign key constraints
                clonedTable.findColumnForeignKeys(oldColumn).forEach(function (foreignKey) {
                  // build new constraint name
                  foreignKey.columnNames.splice(foreignKey.columnNames.indexOf(oldColumn.name), 1);
                  foreignKey.columnNames.push(newColumn.name);
                  var columnNames = foreignKey.columnNames.map(function (column) {
                    return "`".concat(column, "`");
                  }).join(", ");
                  var referencedColumnNames = foreignKey.referencedColumnNames.map(function (column) {
                    return "`".concat(column, "`");
                  }).join(",");
                  var newForeignKeyName = _this6.connection.namingStrategy.foreignKeyName(clonedTable, foreignKey.columnNames);
                  // build queries
                  var up = "ALTER TABLE ".concat(_this6.escapePath(table), " DROP FOREIGN KEY `").concat(foreignKey.name, "`, ADD CONSTRAINT `").concat(newForeignKeyName, "` FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(_this6.escapePath(_this6.getTablePath(foreignKey)), "(").concat(referencedColumnNames, ")");
                  if (foreignKey.onDelete) up += " ON DELETE ".concat(foreignKey.onDelete);
                  if (foreignKey.onUpdate) up += " ON UPDATE ".concat(foreignKey.onUpdate);
                  var down = "ALTER TABLE ".concat(_this6.escapePath(table), " DROP FOREIGN KEY `").concat(newForeignKeyName, "`, ADD CONSTRAINT `").concat(foreignKey.name, "` FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(_this6.escapePath(_this6.getTablePath(foreignKey)), "(").concat(referencedColumnNames, ")");
                  if (foreignKey.onDelete) down += " ON DELETE ".concat(foreignKey.onDelete);
                  if (foreignKey.onUpdate) down += " ON UPDATE ".concat(foreignKey.onUpdate);
                  upQueries.push(new Query(up));
                  downQueries.push(new Query(down));
                  // replace constraint name
                  foreignKey.name = newForeignKeyName;
                });
                // rename old column in the Table object
                oldTableColumn = clonedTable.columns.find(function (column) {
                  return column.name === oldColumn.name;
                });
                clonedTable.columns[clonedTable.columns.indexOf(oldTableColumn)].name = newColumn.name;
                oldColumn.name = newColumn.name;
              }
              if (this.isColumnChanged(oldColumn, newColumn, true)) {
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(oldColumn.name, "` ").concat(this.buildCreateColumnSql(newColumn, true))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(newColumn.name, "` ").concat(this.buildCreateColumnSql(oldColumn, true))));
              }
              if (newColumn.isPrimary !== oldColumn.isPrimary) {
                // if table have generated column, we must drop AUTO_INCREMENT before changing primary constraints.
                generatedColumn = clonedTable.columns.find(function (column) {
                  return column.isGenerated && column.generationStrategy === "increment";
                });
                if (generatedColumn) {
                  nonGeneratedColumn = generatedColumn.clone();
                  nonGeneratedColumn.isGenerated = false;
                  nonGeneratedColumn.generationStrategy = undefined;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(generatedColumn.name, "` ").concat(this.buildCreateColumnSql(nonGeneratedColumn, true))));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(nonGeneratedColumn.name, "` ").concat(this.buildCreateColumnSql(generatedColumn, true))));
                }
                primaryColumns = clonedTable.primaryColumns; // if primary column state changed, we must always drop existed constraint.
                if (primaryColumns.length > 0) {
                  columnNames = primaryColumns.map(function (column) {
                    return "`".concat(column.name, "`");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(columnNames, ")")));
                }
                if (newColumn.isPrimary === true) {
                  primaryColumns.push(newColumn);
                  // update column in table
                  column = clonedTable.columns.find(function (column) {
                    return column.name === newColumn.name;
                  });
                  column.isPrimary = true;
                  _columnNames = primaryColumns.map(function (column) {
                    return "`".concat(column.name, "`");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(_columnNames, ")")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
                } else {
                  primaryColumn = primaryColumns.find(function (c) {
                    return c.name === newColumn.name;
                  });
                  primaryColumns.splice(primaryColumns.indexOf(primaryColumn), 1);
                  // update column in table
                  _column = clonedTable.columns.find(function (column) {
                    return column.name === newColumn.name;
                  });
                  _column.isPrimary = false;
                  // if we have another primary keys, we must recreate constraint.
                  if (primaryColumns.length > 0) {
                    _columnNames2 = primaryColumns.map(function (column) {
                      return "`".concat(column.name, "`");
                    }).join(", ");
                    upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(_columnNames2, ")")));
                    downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
                  }
                }
                // if we have generated column, and we dropped AUTO_INCREMENT property before, we must bring it back
                if (generatedColumn) {
                  _nonGeneratedColumn2 = generatedColumn.clone();
                  _nonGeneratedColumn2.isGenerated = false;
                  _nonGeneratedColumn2.generationStrategy = undefined;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(_nonGeneratedColumn2.name, "` ").concat(this.buildCreateColumnSql(generatedColumn, true))));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(generatedColumn.name, "` ").concat(this.buildCreateColumnSql(_nonGeneratedColumn2, true))));
                }
              }
              if (newColumn.isUnique !== oldColumn.isUnique) {
                if (newColumn.isUnique === true) {
                  uniqueIndex = new TableIndex({
                    name: this.connection.namingStrategy.indexName(table, [newColumn.name]),
                    columnNames: [newColumn.name],
                    isUnique: true
                  });
                  clonedTable.indices.push(uniqueIndex);
                  clonedTable.uniques.push(new TableUnique({
                    name: uniqueIndex.name,
                    columnNames: uniqueIndex.columnNames
                  }));
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD UNIQUE INDEX `").concat(uniqueIndex.name, "` (`").concat(newColumn.name, "`)")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP INDEX `").concat(uniqueIndex.name, "`")));
                } else {
                  _uniqueIndex = clonedTable.indices.find(function (index) {
                    return index.columnNames.length === 1 && index.isUnique === true && !!index.columnNames.find(function (columnName) {
                      return columnName === newColumn.name;
                    });
                  });
                  clonedTable.indices.splice(clonedTable.indices.indexOf(_uniqueIndex), 1);
                  tableUnique = clonedTable.uniques.find(function (unique) {
                    return unique.name === _uniqueIndex.name;
                  });
                  clonedTable.uniques.splice(clonedTable.uniques.indexOf(tableUnique), 1);
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP INDEX `").concat(_uniqueIndex.name, "`")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD UNIQUE INDEX `").concat(_uniqueIndex.name, "` (`").concat(newColumn.name, "`)")));
                }
              }
            case 26:
              _context27.next = 28;
              return this.executeQueries(upQueries, downQueries);
            case 28:
              this.replaceCachedTable(table, clonedTable);
            case 29:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function changeColumn(_x34, _x35, _x36) {
        return _changeColumn.apply(this, arguments);
      }
      return changeColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumns",
    value: function () {
      var _changeColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(tableOrName, changedColumns) {
        var _iterator2, _step2, _step2$value, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(changedColumns);
              _context28.prev = 1;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context28.next = 9;
                break;
              }
              _step2$value = _step2.value, oldColumn = _step2$value.oldColumn, newColumn = _step2$value.newColumn;
              _context28.next = 7;
              return this.changeColumn(tableOrName, oldColumn, newColumn);
            case 7:
              _context28.next = 3;
              break;
            case 9:
              _context28.next = 14;
              break;
            case 11:
              _context28.prev = 11;
              _context28.t0 = _context28["catch"](1);
              _iterator2.e(_context28.t0);
            case 14:
              _context28.prev = 14;
              _iterator2.f();
              return _context28.finish(14);
            case 17:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this, [[1, 11, 14, 17]]);
      }));
      function changeColumns(_x37, _x38) {
        return _changeColumns.apply(this, arguments);
      }
      return changeColumns;
    }()
    /**
     * Drops column in the table.
     */
  }, {
    key: "dropColumn",
    value: function () {
      var _dropColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(tableOrName, columnOrName) {
        var table, column, clonedTable, upQueries, downQueries, generatedColumn, nonGeneratedColumn, columnNames, tableColumn, _columnNames3, _nonGeneratedColumn3, columnIndex, uniqueName, foundUnique, indexName, foundIndex;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context29.next = 4;
                break;
              }
              _context29.t0 = tableOrName;
              _context29.next = 7;
              break;
            case 4:
              _context29.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context29.t0 = _context29.sent;
            case 7:
              table = _context29.t0;
              column = InstanceChecker.isTableColumn(columnOrName) ? columnOrName : table.findColumnByName(columnOrName);
              if (column) {
                _context29.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(columnOrName, "\" was not found in table \"").concat(table.name, "\""));
            case 11:
              clonedTable = table.clone();
              upQueries = [];
              downQueries = []; // drop primary key constraint
              if (column.isPrimary) {
                // if table have generated column, we must drop AUTO_INCREMENT before changing primary constraints.
                generatedColumn = clonedTable.columns.find(function (column) {
                  return column.isGenerated && column.generationStrategy === "increment";
                });
                if (generatedColumn) {
                  nonGeneratedColumn = generatedColumn.clone();
                  nonGeneratedColumn.isGenerated = false;
                  nonGeneratedColumn.generationStrategy = undefined;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(generatedColumn.name, "` ").concat(this.buildCreateColumnSql(nonGeneratedColumn, true))));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(nonGeneratedColumn.name, "` ").concat(this.buildCreateColumnSql(generatedColumn, true))));
                }
                // dropping primary key constraint
                columnNames = clonedTable.primaryColumns.map(function (primaryColumn) {
                  return "`".concat(primaryColumn.name, "`");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " DROP PRIMARY KEY")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " ADD PRIMARY KEY (").concat(columnNames, ")")));
                // update column in table
                tableColumn = clonedTable.findColumnByName(column.name);
                tableColumn.isPrimary = false;
                // if primary key have multiple columns, we must recreate it without dropped column
                if (clonedTable.primaryColumns.length > 0) {
                  _columnNames3 = clonedTable.primaryColumns.map(function (primaryColumn) {
                    return "`".concat(primaryColumn.name, "`");
                  }).join(", ");
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " ADD PRIMARY KEY (").concat(_columnNames3, ")")));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(clonedTable), " DROP PRIMARY KEY")));
                }
                // if we have generated column, and we dropped AUTO_INCREMENT property before, and this column is not current dropping column, we must bring it back
                if (generatedColumn && generatedColumn.name !== column.name) {
                  _nonGeneratedColumn3 = generatedColumn.clone();
                  _nonGeneratedColumn3.isGenerated = false;
                  _nonGeneratedColumn3.generationStrategy = undefined;
                  upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(_nonGeneratedColumn3.name, "` ").concat(this.buildCreateColumnSql(generatedColumn, true))));
                  downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(generatedColumn.name, "` ").concat(this.buildCreateColumnSql(_nonGeneratedColumn3, true))));
                }
              }
              // drop column index
              columnIndex = clonedTable.indices.find(function (index) {
                return index.columnNames.length === 1 && index.columnNames[0] === column.name;
              });
              if (columnIndex) {
                clonedTable.indices.splice(clonedTable.indices.indexOf(columnIndex), 1);
                upQueries.push(this.dropIndexSql(table, columnIndex));
                downQueries.push(this.createIndexSql(table, columnIndex));
              } else if (column.isUnique) {
                // we splice constraints both from table uniques and indices.
                uniqueName = this.connection.namingStrategy.uniqueConstraintName(table, [column.name]);
                foundUnique = clonedTable.uniques.find(function (unique) {
                  return unique.name === uniqueName;
                });
                if (foundUnique) clonedTable.uniques.splice(clonedTable.uniques.indexOf(foundUnique), 1);
                indexName = this.connection.namingStrategy.indexName(table, [column.name]);
                foundIndex = clonedTable.indices.find(function (index) {
                  return index.name === indexName;
                });
                if (foundIndex) clonedTable.indices.splice(clonedTable.indices.indexOf(foundIndex), 1);
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP INDEX `").concat(indexName, "`")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD UNIQUE INDEX `").concat(indexName, "` (`").concat(column.name, "`)")));
              }
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP COLUMN `").concat(column.name, "`")));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD ").concat(this.buildCreateColumnSql(column, true))));
              _context29.next = 21;
              return this.executeQueries(upQueries, downQueries);
            case 21:
              clonedTable.removeColumn(column);
              this.replaceCachedTable(table, clonedTable);
            case 23:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function dropColumn(_x39, _x40) {
        return _dropColumn.apply(this, arguments);
      }
      return dropColumn;
    }()
    /**
     * Drops the columns in the table.
     */
  }, {
    key: "dropColumns",
    value: function () {
      var _dropColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(tableOrName, columns) {
        var _iterator3, _step3, column;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(columns);
              _context30.prev = 1;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context30.next = 9;
                break;
              }
              column = _step3.value;
              _context30.next = 7;
              return this.dropColumn(tableOrName, column);
            case 7:
              _context30.next = 3;
              break;
            case 9:
              _context30.next = 14;
              break;
            case 11:
              _context30.prev = 11;
              _context30.t0 = _context30["catch"](1);
              _iterator3.e(_context30.t0);
            case 14:
              _context30.prev = 14;
              _iterator3.f();
              return _context30.finish(14);
            case 17:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this, [[1, 11, 14, 17]]);
      }));
      function dropColumns(_x41, _x42) {
        return _dropColumns.apply(this, arguments);
      }
      return dropColumns;
    }()
    /**
     * Creates a new primary key.
     */
  }, {
    key: "createPrimaryKey",
    value: function () {
      var _createPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(tableOrName, columnNames) {
        var table, clonedTable, up, down;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context31.next = 4;
                break;
              }
              _context31.t0 = tableOrName;
              _context31.next = 7;
              break;
            case 4:
              _context31.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context31.t0 = _context31.sent;
            case 7:
              table = _context31.t0;
              clonedTable = table.clone();
              up = this.createPrimaryKeySql(table, columnNames);
              down = this.dropPrimaryKeySql(table);
              _context31.next = 13;
              return this.executeQueries(up, down);
            case 13:
              clonedTable.columns.forEach(function (column) {
                if (columnNames.find(function (columnName) {
                  return columnName === column.name;
                })) column.isPrimary = true;
              });
              this.replaceCachedTable(table, clonedTable);
            case 15:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function createPrimaryKey(_x43, _x44) {
        return _createPrimaryKey.apply(this, arguments);
      }
      return createPrimaryKey;
    }()
    /**
     * Updates composite primary keys.
     */
  }, {
    key: "updatePrimaryKeys",
    value: function () {
      var _updatePrimaryKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(tableOrName, columns) {
        var table, clonedTable, columnNames, upQueries, downQueries, generatedColumn, nonGeneratedColumn, primaryColumns, _columnNames4, columnNamesString, newOrExistGeneratedColumn, _nonGeneratedColumn4, changedGeneratedColumn;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context32.next = 4;
                break;
              }
              _context32.t0 = tableOrName;
              _context32.next = 7;
              break;
            case 4:
              _context32.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context32.t0 = _context32.sent;
            case 7:
              table = _context32.t0;
              clonedTable = table.clone();
              columnNames = columns.map(function (column) {
                return column.name;
              });
              upQueries = [];
              downQueries = []; // if table have generated column, we must drop AUTO_INCREMENT before changing primary constraints.
              generatedColumn = clonedTable.columns.find(function (column) {
                return column.isGenerated && column.generationStrategy === "increment";
              });
              if (generatedColumn) {
                nonGeneratedColumn = generatedColumn.clone();
                nonGeneratedColumn.isGenerated = false;
                nonGeneratedColumn.generationStrategy = undefined;
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(generatedColumn.name, "` ").concat(this.buildCreateColumnSql(nonGeneratedColumn, true))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(nonGeneratedColumn.name, "` ").concat(this.buildCreateColumnSql(generatedColumn, true))));
              }
              // if table already have primary columns, we must drop them.
              primaryColumns = clonedTable.primaryColumns;
              if (primaryColumns.length > 0) {
                _columnNames4 = primaryColumns.map(function (column) {
                  return "`".concat(column.name, "`");
                }).join(", ");
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(_columnNames4, ")")));
              }
              // update columns in table.
              clonedTable.columns.filter(function (column) {
                return columnNames.indexOf(column.name) !== -1;
              }).forEach(function (column) {
                return column.isPrimary = true;
              });
              columnNamesString = columnNames.map(function (columnName) {
                return "`".concat(columnName, "`");
              }).join(", ");
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(columnNamesString, ")")));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY")));
              // if we already have generated column or column is changed to generated, and we dropped AUTO_INCREMENT property before, we must bring it back
              newOrExistGeneratedColumn = generatedColumn ? generatedColumn : columns.find(function (column) {
                return column.isGenerated && column.generationStrategy === "increment";
              });
              if (newOrExistGeneratedColumn) {
                _nonGeneratedColumn4 = newOrExistGeneratedColumn.clone();
                _nonGeneratedColumn4.isGenerated = false;
                _nonGeneratedColumn4.generationStrategy = undefined;
                upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(_nonGeneratedColumn4.name, "` ").concat(this.buildCreateColumnSql(newOrExistGeneratedColumn, true))));
                downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(table), " CHANGE `").concat(newOrExistGeneratedColumn.name, "` ").concat(this.buildCreateColumnSql(_nonGeneratedColumn4, true))));
                // if column changed to generated, we must update it in table
                changedGeneratedColumn = clonedTable.columns.find(function (column) {
                  return column.name === newOrExistGeneratedColumn.name;
                });
                changedGeneratedColumn.isGenerated = true;
                changedGeneratedColumn.generationStrategy = "increment";
              }
              _context32.next = 24;
              return this.executeQueries(upQueries, downQueries);
            case 24:
              this.replaceCachedTable(table, clonedTable);
            case 25:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function updatePrimaryKeys(_x45, _x46) {
        return _updatePrimaryKeys.apply(this, arguments);
      }
      return updatePrimaryKeys;
    }()
    /**
     * Drops a primary key.
     */
  }, {
    key: "dropPrimaryKey",
    value: function () {
      var _dropPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(tableOrName) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context33.next = 4;
                break;
              }
              _context33.t0 = tableOrName;
              _context33.next = 7;
              break;
            case 4:
              _context33.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context33.t0 = _context33.sent;
            case 7:
              table = _context33.t0;
              up = this.dropPrimaryKeySql(table);
              down = this.createPrimaryKeySql(table, table.primaryColumns.map(function (column) {
                return column.name;
              }));
              _context33.next = 12;
              return this.executeQueries(up, down);
            case 12:
              table.primaryColumns.forEach(function (column) {
                column.isPrimary = false;
              });
            case 13:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function dropPrimaryKey(_x47) {
        return _dropPrimaryKey.apply(this, arguments);
      }
      return dropPrimaryKey;
    }()
    /**
     * Creates a new unique constraint.
     */
  }, {
    key: "createUniqueConstraint",
    value: function () {
      var _createUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(tableOrName, uniqueConstraint) {
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              throw new TypeORMError("MySql does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
      function createUniqueConstraint(_x48, _x49) {
        return _createUniqueConstraint.apply(this, arguments);
      }
      return createUniqueConstraint;
    }()
    /**
     * Creates a new unique constraints.
     */
  }, {
    key: "createUniqueConstraints",
    value: function () {
      var _createUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(tableOrName, uniqueConstraints) {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              throw new TypeORMError("MySql does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }));
      function createUniqueConstraints(_x50, _x51) {
        return _createUniqueConstraints.apply(this, arguments);
      }
      return createUniqueConstraints;
    }()
    /**
     * Drops an unique constraint.
     */
  }, {
    key: "dropUniqueConstraint",
    value: function () {
      var _dropUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(tableOrName, uniqueOrName) {
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              throw new TypeORMError("MySql does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      function dropUniqueConstraint(_x52, _x53) {
        return _dropUniqueConstraint.apply(this, arguments);
      }
      return dropUniqueConstraint;
    }()
    /**
     * Drops an unique constraints.
     */
  }, {
    key: "dropUniqueConstraints",
    value: function () {
      var _dropUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(tableOrName, uniqueConstraints) {
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              throw new TypeORMError("MySql does not support unique constraints. Use unique index instead.");
            case 1:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }));
      function dropUniqueConstraints(_x54, _x55) {
        return _dropUniqueConstraints.apply(this, arguments);
      }
      return dropUniqueConstraints;
    }()
    /**
     * Creates a new check constraint.
     */
  }, {
    key: "createCheckConstraint",
    value: function () {
      var _createCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(tableOrName, checkConstraint) {
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              throw new TypeORMError("MySql does not support check constraints.");
            case 1:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      }));
      function createCheckConstraint(_x56, _x57) {
        return _createCheckConstraint.apply(this, arguments);
      }
      return createCheckConstraint;
    }()
    /**
     * Creates a new check constraints.
     */
  }, {
    key: "createCheckConstraints",
    value: function () {
      var _createCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(tableOrName, checkConstraints) {
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              throw new TypeORMError("MySql does not support check constraints.");
            case 1:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
      function createCheckConstraints(_x58, _x59) {
        return _createCheckConstraints.apply(this, arguments);
      }
      return createCheckConstraints;
    }()
    /**
     * Drops check constraint.
     */
  }, {
    key: "dropCheckConstraint",
    value: function () {
      var _dropCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(tableOrName, checkOrName) {
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              throw new TypeORMError("MySql does not support check constraints.");
            case 1:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }));
      function dropCheckConstraint(_x60, _x61) {
        return _dropCheckConstraint.apply(this, arguments);
      }
      return dropCheckConstraint;
    }()
    /**
     * Drops check constraints.
     */
  }, {
    key: "dropCheckConstraints",
    value: function () {
      var _dropCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(tableOrName, checkConstraints) {
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              throw new TypeORMError("MySql does not support check constraints.");
            case 1:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
      function dropCheckConstraints(_x62, _x63) {
        return _dropCheckConstraints.apply(this, arguments);
      }
      return dropCheckConstraints;
    }()
    /**
     * Creates a new exclusion constraint.
     */
  }, {
    key: "createExclusionConstraint",
    value: function () {
      var _createExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(tableOrName, exclusionConstraint) {
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              throw new TypeORMError("MySql does not support exclusion constraints.");
            case 1:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
      function createExclusionConstraint(_x64, _x65) {
        return _createExclusionConstraint.apply(this, arguments);
      }
      return createExclusionConstraint;
    }()
    /**
     * Creates a new exclusion constraints.
     */
  }, {
    key: "createExclusionConstraints",
    value: function () {
      var _createExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(tableOrName, exclusionConstraints) {
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              throw new TypeORMError("MySql does not support exclusion constraints.");
            case 1:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      }));
      function createExclusionConstraints(_x66, _x67) {
        return _createExclusionConstraints.apply(this, arguments);
      }
      return createExclusionConstraints;
    }()
    /**
     * Drops exclusion constraint.
     */
  }, {
    key: "dropExclusionConstraint",
    value: function () {
      var _dropExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(tableOrName, exclusionOrName) {
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              throw new TypeORMError("MySql does not support exclusion constraints.");
            case 1:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      }));
      function dropExclusionConstraint(_x68, _x69) {
        return _dropExclusionConstraint.apply(this, arguments);
      }
      return dropExclusionConstraint;
    }()
    /**
     * Drops exclusion constraints.
     */
  }, {
    key: "dropExclusionConstraints",
    value: function () {
      var _dropExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(tableOrName, exclusionConstraints) {
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              throw new TypeORMError("MySql does not support exclusion constraints.");
            case 1:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      }));
      function dropExclusionConstraints(_x70, _x71) {
        return _dropExclusionConstraints.apply(this, arguments);
      }
      return dropExclusionConstraints;
    }()
    /**
     * Creates a new foreign key.
     */
  }, {
    key: "createForeignKey",
    value: function () {
      var _createForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(tableOrName, foreignKey) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context46.next = 4;
                break;
              }
              _context46.t0 = tableOrName;
              _context46.next = 7;
              break;
            case 4:
              _context46.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context46.t0 = _context46.sent;
            case 7:
              table = _context46.t0;
              // new FK may be passed without name. In this case we generate FK name manually.
              if (!foreignKey.name) foreignKey.name = this.connection.namingStrategy.foreignKeyName(table, foreignKey.columnNames);
              up = this.createForeignKeySql(table, foreignKey);
              down = this.dropForeignKeySql(table, foreignKey);
              _context46.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addForeignKey(foreignKey);
            case 14:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function createForeignKey(_x72, _x73) {
        return _createForeignKey.apply(this, arguments);
      }
      return createForeignKey;
    }()
    /**
     * Creates a new foreign keys.
     */
  }, {
    key: "createForeignKeys",
    value: function () {
      var _createForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(tableOrName, foreignKeys) {
        var _this7 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              promises = foreignKeys.map(function (foreignKey) {
                return _this7.createForeignKey(tableOrName, foreignKey);
              });
              _context47.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }));
      function createForeignKeys(_x74, _x75) {
        return _createForeignKeys.apply(this, arguments);
      }
      return createForeignKeys;
    }()
    /**
     * Drops a foreign key.
     */
  }, {
    key: "dropForeignKey",
    value: function () {
      var _dropForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(tableOrName, foreignKeyOrName) {
        var table, foreignKey, up, down;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context48.next = 4;
                break;
              }
              _context48.t0 = tableOrName;
              _context48.next = 7;
              break;
            case 4:
              _context48.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context48.t0 = _context48.sent;
            case 7:
              table = _context48.t0;
              foreignKey = InstanceChecker.isTableForeignKey(foreignKeyOrName) ? foreignKeyOrName : table.foreignKeys.find(function (fk) {
                return fk.name === foreignKeyOrName;
              });
              if (foreignKey) {
                _context48.next = 11;
                break;
              }
              throw new TypeORMError("Supplied foreign key was not found in table ".concat(table.name));
            case 11:
              up = this.dropForeignKeySql(table, foreignKey);
              down = this.createForeignKeySql(table, foreignKey);
              _context48.next = 15;
              return this.executeQueries(up, down);
            case 15:
              table.removeForeignKey(foreignKey);
            case 16:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function dropForeignKey(_x76, _x77) {
        return _dropForeignKey.apply(this, arguments);
      }
      return dropForeignKey;
    }()
    /**
     * Drops a foreign keys from the table.
     */
  }, {
    key: "dropForeignKeys",
    value: function () {
      var _dropForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(tableOrName, foreignKeys) {
        var _this8 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              promises = foreignKeys.map(function (foreignKey) {
                return _this8.dropForeignKey(tableOrName, foreignKey);
              });
              _context49.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context49.stop();
          }
        }, _callee49);
      }));
      function dropForeignKeys(_x78, _x79) {
        return _dropForeignKeys.apply(this, arguments);
      }
      return dropForeignKeys;
    }()
    /**
     * Creates a new index.
     */
  }, {
    key: "createIndex",
    value: function () {
      var _createIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(tableOrName, index) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context50.next = 4;
                break;
              }
              _context50.t0 = tableOrName;
              _context50.next = 7;
              break;
            case 4:
              _context50.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context50.t0 = _context50.sent;
            case 7:
              table = _context50.t0;
              // new index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.createIndexSql(table, index);
              down = this.dropIndexSql(table, index);
              _context50.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addIndex(index, true);
            case 14:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function createIndex(_x80, _x81) {
        return _createIndex.apply(this, arguments);
      }
      return createIndex;
    }()
    /**
     * Creates a new indices
     */
  }, {
    key: "createIndices",
    value: function () {
      var _createIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(tableOrName, indices) {
        var _this9 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              promises = indices.map(function (index) {
                return _this9.createIndex(tableOrName, index);
              });
              _context51.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context51.stop();
          }
        }, _callee51);
      }));
      function createIndices(_x82, _x83) {
        return _createIndices.apply(this, arguments);
      }
      return createIndices;
    }()
    /**
     * Drops an index.
     */
  }, {
    key: "dropIndex",
    value: function () {
      var _dropIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(tableOrName, indexOrName) {
        var table, index, up, down;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context52.next = 4;
                break;
              }
              _context52.t0 = tableOrName;
              _context52.next = 7;
              break;
            case 4:
              _context52.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context52.t0 = _context52.sent;
            case 7:
              table = _context52.t0;
              index = InstanceChecker.isTableIndex(indexOrName) ? indexOrName : table.indices.find(function (i) {
                return i.name === indexOrName;
              });
              if (index) {
                _context52.next = 11;
                break;
              }
              throw new TypeORMError("Supplied index ".concat(indexOrName, " was not found in table ").concat(table.name));
            case 11:
              // old index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.dropIndexSql(table, index);
              down = this.createIndexSql(table, index);
              _context52.next = 16;
              return this.executeQueries(up, down);
            case 16:
              table.removeIndex(index, true);
            case 17:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this);
      }));
      function dropIndex(_x84, _x85) {
        return _dropIndex.apply(this, arguments);
      }
      return dropIndex;
    }()
    /**
     * Drops an indices from the table.
     */
  }, {
    key: "dropIndices",
    value: function () {
      var _dropIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(tableOrName, indices) {
        var _this10 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              promises = indices.map(function (index) {
                return _this10.dropIndex(tableOrName, index);
              });
              _context53.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context53.stop();
          }
        }, _callee53);
      }));
      function dropIndices(_x86, _x87) {
        return _dropIndices.apply(this, arguments);
      }
      return dropIndices;
    }()
    /**
     * Clears all table contents.
     * Note: this operation uses SQL's TRUNCATE query which cannot be reverted in transactions.
     */
  }, {
    key: "clearTable",
    value: function () {
      var _clearTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(tableOrName) {
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 2;
              return this.query("TRUNCATE TABLE ".concat(this.escapePath(tableOrName)));
            case 2:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function clearTable(_x88) {
        return _clearTable.apply(this, arguments);
      }
      return clearTable;
    }()
    /**
     * Removes all tables from the currently connected database.
     * Be careful using this method and avoid using it in production or migrations
     * (because it can clear all your database).
     */
  }, {
    key: "clearDatabase",
    value: function () {
      var _clearDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(database) {
        var _this11 = this;
        var dbName, isDatabaseExist, isAnotherTransactionActive, selectViewDropsQuery, dropViewQueries, disableForeignKeysCheckQuery, dropTablesQuery, enableForeignKeysCheckQuery, dropQueries;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              dbName = database ? database : this.driver.database;
              if (!dbName) {
                _context55.next = 9;
                break;
              }
              _context55.next = 4;
              return this.hasDatabase(dbName);
            case 4:
              isDatabaseExist = _context55.sent;
              if (isDatabaseExist) {
                _context55.next = 7;
                break;
              }
              return _context55.abrupt("return", Promise.resolve());
            case 7:
              _context55.next = 10;
              break;
            case 9:
              throw new TypeORMError("Can not clear database. No database is specified");
            case 10:
              isAnotherTransactionActive = this.isTransactionActive;
              if (isAnotherTransactionActive) {
                _context55.next = 14;
                break;
              }
              _context55.next = 14;
              return this.startTransaction();
            case 14:
              _context55.prev = 14;
              selectViewDropsQuery = "SELECT concat('DROP VIEW IF EXISTS `', table_schema, '`.`', table_name, '`') AS `query` FROM `INFORMATION_SCHEMA`.`VIEWS` WHERE `TABLE_SCHEMA` = '".concat(dbName, "'");
              _context55.next = 18;
              return this.query(selectViewDropsQuery);
            case 18:
              dropViewQueries = _context55.sent;
              _context55.next = 21;
              return Promise.all(dropViewQueries.map(function (q) {
                return _this11.query(q["query"]);
              }));
            case 21:
              disableForeignKeysCheckQuery = "SET FOREIGN_KEY_CHECKS = 0;";
              dropTablesQuery = "SELECT concat('DROP TABLE IF EXISTS `', table_schema, '`.`', table_name, '`') AS `query` FROM `INFORMATION_SCHEMA`.`TABLES` WHERE `TABLE_SCHEMA` = '".concat(dbName, "'");
              enableForeignKeysCheckQuery = "SET FOREIGN_KEY_CHECKS = 1;";
              _context55.next = 26;
              return this.query(disableForeignKeysCheckQuery);
            case 26:
              _context55.next = 28;
              return this.query(dropTablesQuery);
            case 28:
              dropQueries = _context55.sent;
              _context55.next = 31;
              return Promise.all(dropQueries.map(function (query) {
                return _this11.query(query["query"]);
              }));
            case 31:
              _context55.next = 33;
              return this.query(enableForeignKeysCheckQuery);
            case 33:
              if (isAnotherTransactionActive) {
                _context55.next = 36;
                break;
              }
              _context55.next = 36;
              return this.commitTransaction();
            case 36:
              _context55.next = 49;
              break;
            case 38:
              _context55.prev = 38;
              _context55.t0 = _context55["catch"](14);
              _context55.prev = 40;
              if (isAnotherTransactionActive) {
                _context55.next = 44;
                break;
              }
              _context55.next = 44;
              return this.rollbackTransaction();
            case 44:
              _context55.next = 48;
              break;
            case 46:
              _context55.prev = 46;
              _context55.t1 = _context55["catch"](40);
            case 48:
              throw _context55.t0;
            case 49:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this, [[14, 38], [40, 46]]);
      }));
      function clearDatabase(_x89) {
        return _clearDatabase.apply(this, arguments);
      }
      return clearDatabase;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
  }, {
    key: "loadViews",
    value: function () {
      var _loadViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(viewNames) {
        var _this12 = this;
        var hasTable, currentDatabase, viewsCondition, query, dbViews;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return this.hasTable(this.getTypeormMetadataTableName());
            case 2:
              hasTable = _context56.sent;
              if (hasTable) {
                _context56.next = 5;
                break;
              }
              return _context56.abrupt("return", []);
            case 5:
              if (!viewNames) {
                viewNames = [];
              }
              _context56.next = 8;
              return this.getCurrentDatabase();
            case 8:
              currentDatabase = _context56.sent;
              viewsCondition = viewNames.map(function (tableName) {
                var _this12$driver$parseT = _this12.driver.parseTableName(tableName),
                  database = _this12$driver$parseT.database,
                  name = _this12$driver$parseT.tableName;
                if (!database) {
                  database = currentDatabase;
                }
                return "(`t`.`schema` = '".concat(database, "' AND `t`.`name` = '").concat(name, "')");
              }).join(" OR ");
              query = "SELECT `t`.*, `v`.`check_option` FROM ".concat(this.escapePath(this.getTypeormMetadataTableName()), " `t` ") + "INNER JOIN `information_schema`.`views` `v` ON `v`.`table_schema` = `t`.`schema` AND `v`.`table_name` = `t`.`name` WHERE `t`.`type` = '".concat(MetadataTableType.VIEW, "' ").concat(viewsCondition ? "AND (".concat(viewsCondition, ")") : "");
              _context56.next = 13;
              return this.query(query);
            case 13:
              dbViews = _context56.sent;
              return _context56.abrupt("return", dbViews.map(function (dbView) {
                var view = new View();
                var db = dbView["schema"] === currentDatabase ? undefined : dbView["schema"];
                view.database = dbView["schema"];
                view.name = _this12.driver.buildTableName(dbView["name"], undefined, db);
                view.expression = dbView["value"];
                return view;
              }));
            case 15:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
      function loadViews(_x90) {
        return _loadViews.apply(this, arguments);
      }
      return loadViews;
    }()
    /**
     * Loads all tables (with given names) from the database and creates a Table from them.
     */
  }, {
    key: "loadTables",
    value: function () {
      var _loadTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58(tableNames) {
        var _this13 = this;
        var dbTables, currentDatabase, tablesSql, tablesCondition, _tablesSql, columnsCondition, columnsSql, primaryKeySql, collationsSql, indicesCondition, indicesSql, foreignKeysCondition, foreignKeysSql, _yield$Promise$all, _yield$Promise$all2, dbColumns, dbPrimaryKeys, dbCollations, dbIndices, dbForeignKeys;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              if (!(tableNames && tableNames.length === 0)) {
                _context58.next = 2;
                break;
              }
              return _context58.abrupt("return", []);
            case 2:
              dbTables = [];
              _context58.next = 5;
              return this.getCurrentDatabase();
            case 5:
              currentDatabase = _context58.sent;
              if (tableNames) {
                _context58.next = 18;
                break;
              }
              tablesSql = "SELECT TABLE_NAME, TABLE_SCHEMA FROM `INFORMATION_SCHEMA`.`TABLES`";
              _context58.t0 = dbTables.push;
              _context58.t1 = dbTables;
              _context58.t2 = _toConsumableArray;
              _context58.next = 13;
              return this.query(tablesSql);
            case 13:
              _context58.t3 = _context58.sent;
              _context58.t4 = (0, _context58.t2)(_context58.t3);
              _context58.t0.apply.call(_context58.t0, _context58.t1, _context58.t4);
              _context58.next = 28;
              break;
            case 18:
              tablesCondition = tableNames.map(function (tableName) {
                var _tableName$split = tableName.split("."),
                  _tableName$split2 = _slicedToArray(_tableName$split, 2),
                  database = _tableName$split2[0],
                  name = _tableName$split2[1];
                if (!name) {
                  name = database;
                  database = _this13.driver.database || currentDatabase;
                }
                return "(`TABLE_SCHEMA` = '".concat(database, "' AND `TABLE_NAME` = '").concat(name, "')");
              }).join(" OR ");
              _tablesSql = "SELECT TABLE_NAME, TABLE_SCHEMA FROM `INFORMATION_SCHEMA`.`TABLES` WHERE " + tablesCondition;
              _context58.t5 = dbTables.push;
              _context58.t6 = dbTables;
              _context58.t7 = _toConsumableArray;
              _context58.next = 25;
              return this.query(_tablesSql);
            case 25:
              _context58.t8 = _context58.sent;
              _context58.t9 = (0, _context58.t7)(_context58.t8);
              _context58.t5.apply.call(_context58.t5, _context58.t6, _context58.t9);
            case 28:
              if (!(dbTables.length === 0)) {
                _context58.next = 30;
                break;
              }
              return _context58.abrupt("return", []);
            case 30:
              columnsCondition = dbTables.map(function (_ref2) {
                var TABLE_NAME = _ref2.TABLE_NAME,
                  TABLE_SCHEMA = _ref2.TABLE_SCHEMA;
                return "(`TABLE_SCHEMA` = '".concat(TABLE_SCHEMA, "' AND `TABLE_NAME` = '").concat(TABLE_NAME, "')");
              }).join(" OR ");
              columnsSql = "SELECT * FROM `INFORMATION_SCHEMA`.`COLUMNS` WHERE " + columnsCondition;
              primaryKeySql = "SELECT * FROM `INFORMATION_SCHEMA`.`KEY_COLUMN_USAGE` WHERE `CONSTRAINT_NAME` = 'PRIMARY' AND (".concat(columnsCondition, ")");
              collationsSql = "SELECT `SCHEMA_NAME`, `DEFAULT_CHARACTER_SET_NAME` as `CHARSET`, `DEFAULT_COLLATION_NAME` AS `COLLATION` FROM `INFORMATION_SCHEMA`.`SCHEMATA`";
              indicesCondition = dbTables.map(function (_ref3) {
                var TABLE_NAME = _ref3.TABLE_NAME,
                  TABLE_SCHEMA = _ref3.TABLE_SCHEMA;
                return "(`s`.`TABLE_SCHEMA` = '".concat(TABLE_SCHEMA, "' AND `s`.`TABLE_NAME` = '").concat(TABLE_NAME, "')");
              }).join(" OR ");
              indicesSql = "SELECT `s`.* FROM `INFORMATION_SCHEMA`.`STATISTICS` `s` " + "LEFT JOIN `INFORMATION_SCHEMA`.`REFERENTIAL_CONSTRAINTS` `rc` ON `s`.`INDEX_NAME` = `rc`.`CONSTRAINT_NAME` " + "WHERE (".concat(indicesCondition, ") AND `s`.`INDEX_NAME` != 'PRIMARY' AND `rc`.`CONSTRAINT_NAME` IS NULL");
              foreignKeysCondition = dbTables.map(function (_ref4) {
                var TABLE_NAME = _ref4.TABLE_NAME,
                  TABLE_SCHEMA = _ref4.TABLE_SCHEMA;
                return "(`kcu`.`TABLE_SCHEMA` = '".concat(TABLE_SCHEMA, "' AND `kcu`.`TABLE_NAME` = '").concat(TABLE_NAME, "')");
              }).join(" OR ");
              foreignKeysSql = "SELECT `kcu`.`TABLE_SCHEMA`, `kcu`.`TABLE_NAME`, `kcu`.`CONSTRAINT_NAME`, `kcu`.`COLUMN_NAME`, `kcu`.`REFERENCED_TABLE_SCHEMA`, " + "`kcu`.`REFERENCED_TABLE_NAME`, `kcu`.`REFERENCED_COLUMN_NAME`, `rc`.`DELETE_RULE` `ON_DELETE`, `rc`.`UPDATE_RULE` `ON_UPDATE` " + "FROM `INFORMATION_SCHEMA`.`KEY_COLUMN_USAGE` `kcu` " + "INNER JOIN `INFORMATION_SCHEMA`.`REFERENTIAL_CONSTRAINTS` `rc` ON `rc`.`constraint_name` = `kcu`.`constraint_name` " + "WHERE " + foreignKeysCondition;
              _context58.next = 40;
              return Promise.all([this.query(columnsSql), this.query(primaryKeySql), this.query(collationsSql), this.query(indicesSql), this.query(foreignKeysSql)]);
            case 40:
              _yield$Promise$all = _context58.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 5);
              dbColumns = _yield$Promise$all2[0];
              dbPrimaryKeys = _yield$Promise$all2[1];
              dbCollations = _yield$Promise$all2[2];
              dbIndices = _yield$Promise$all2[3];
              dbForeignKeys = _yield$Promise$all2[4];
              return _context58.abrupt("return", Promise.all(dbTables.map( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57(dbTable) {
                  var table, dbCollation, defaultCollation, defaultCharset, db, tableForeignKeyConstraints, tableIndexConstraints;
                  return _regeneratorRuntime().wrap(function _callee57$(_context57) {
                    while (1) switch (_context57.prev = _context57.next) {
                      case 0:
                        table = new Table();
                        dbCollation = dbCollations.find(function (coll) {
                          return coll["SCHEMA_NAME"] === dbTable["TABLE_SCHEMA"];
                        });
                        defaultCollation = dbCollation["COLLATION"];
                        defaultCharset = dbCollation["CHARSET"]; // We do not need to join database name, when database is by default.
                        db = dbTable["TABLE_SCHEMA"] === currentDatabase ? undefined : dbTable["TABLE_SCHEMA"];
                        table.database = dbTable["TABLE_SCHEMA"];
                        table.name = _this13.driver.buildTableName(dbTable["TABLE_NAME"], undefined, db);
                        // create columns from the loaded columns
                        table.columns = dbColumns.filter(function (dbColumn) {
                          return dbColumn["TABLE_NAME"] === dbTable["TABLE_NAME"] && dbColumn["TABLE_SCHEMA"] === dbTable["TABLE_SCHEMA"];
                        }).map(function (dbColumn) {
                          var columnUniqueIndices = dbIndices.filter(function (dbIndex) {
                            return dbIndex["TABLE_NAME"] === dbTable["TABLE_NAME"] && dbIndex["TABLE_SCHEMA"] === dbTable["TABLE_SCHEMA"] && dbIndex["COLUMN_NAME"] === dbColumn["COLUMN_NAME"] && parseInt(dbIndex["NON_UNIQUE"], 10) === 0;
                          });
                          var tableMetadata = _this13.connection.entityMetadatas.find(function (metadata) {
                            return _this13.getTablePath(table) === _this13.getTablePath(metadata);
                          });
                          var hasIgnoredIndex = columnUniqueIndices.length > 0 && tableMetadata && tableMetadata.indices.some(function (index) {
                            return columnUniqueIndices.some(function (uniqueIndex) {
                              return index.name === uniqueIndex["INDEX_NAME"] && index.synchronize === false;
                            });
                          });
                          var isConstraintComposite = columnUniqueIndices.every(function (uniqueIndex) {
                            return dbIndices.some(function (dbIndex) {
                              return dbIndex["INDEX_NAME"] === uniqueIndex["INDEX_NAME"] && dbIndex["COLUMN_NAME"] !== dbColumn["COLUMN_NAME"];
                            });
                          });
                          var tableColumn = new TableColumn();
                          tableColumn.name = dbColumn["COLUMN_NAME"];
                          tableColumn.type = dbColumn["DATA_TYPE"].toLowerCase();
                          // Unsigned columns are handled differently when it comes to width.
                          // Hence, we need to set the unsigned attribute before we check the width.
                          tableColumn.unsigned = tableColumn.zerofill ? true : dbColumn["COLUMN_TYPE"].indexOf("unsigned") !== -1;
                          if (_this13.driver.withWidthColumnTypes.indexOf(tableColumn.type) !== -1) {
                            var width = dbColumn["COLUMN_TYPE"].substring(dbColumn["COLUMN_TYPE"].indexOf("(") + 1, dbColumn["COLUMN_TYPE"].indexOf(")"));
                            tableColumn.width = width && !_this13.isDefaultColumnWidth(table, tableColumn, parseInt(width)) ? parseInt(width) : undefined;
                          }
                          if (dbColumn["COLUMN_DEFAULT"] === null || dbColumn["COLUMN_DEFAULT"] === undefined) {
                            tableColumn.default = undefined;
                          } else {
                            tableColumn.default = dbColumn["COLUMN_DEFAULT"] === "CURRENT_TIMESTAMP" ? dbColumn["COLUMN_DEFAULT"] : "'".concat(dbColumn["COLUMN_DEFAULT"], "'");
                          }
                          if (dbColumn["EXTRA"].indexOf("on update") !== -1) {
                            tableColumn.onUpdate = dbColumn["EXTRA"].substring(dbColumn["EXTRA"].indexOf("on update") + 10);
                          }
                          if (dbColumn["GENERATION_EXPRESSION"]) {
                            tableColumn.asExpression = dbColumn["GENERATION_EXPRESSION"];
                            tableColumn.generatedType = dbColumn["EXTRA"].indexOf("VIRTUAL") !== -1 ? "VIRTUAL" : "STORED";
                          }
                          tableColumn.isUnique = columnUniqueIndices.length > 0 && !hasIgnoredIndex && !isConstraintComposite;
                          tableColumn.isNullable = dbColumn["IS_NULLABLE"] === "YES";
                          tableColumn.isPrimary = dbPrimaryKeys.some(function (dbPrimaryKey) {
                            return dbPrimaryKey["TABLE_NAME"] === dbColumn["TABLE_NAME"] && dbPrimaryKey["TABLE_SCHEMA"] === dbColumn["TABLE_SCHEMA"] && dbPrimaryKey["COLUMN_NAME"] === dbColumn["COLUMN_NAME"];
                          });
                          tableColumn.zerofill = dbColumn["COLUMN_TYPE"].indexOf("zerofill") !== -1;
                          tableColumn.isGenerated = dbColumn["EXTRA"].indexOf("auto_increment") !== -1;
                          if (tableColumn.isGenerated) tableColumn.generationStrategy = "increment";
                          tableColumn.comment = typeof dbColumn["COLUMN_COMMENT"] === "string" && dbColumn["COLUMN_COMMENT"].length === 0 ? undefined : dbColumn["COLUMN_COMMENT"];
                          if (dbColumn["CHARACTER_SET_NAME"]) tableColumn.charset = dbColumn["CHARACTER_SET_NAME"] === defaultCharset ? undefined : dbColumn["CHARACTER_SET_NAME"];
                          if (dbColumn["COLLATION_NAME"]) tableColumn.collation = dbColumn["COLLATION_NAME"] === defaultCollation ? undefined : dbColumn["COLLATION_NAME"];
                          // check only columns that have length property
                          if (_this13.driver.withLengthColumnTypes.indexOf(tableColumn.type) !== -1 && dbColumn["CHARACTER_MAXIMUM_LENGTH"]) {
                            var length = dbColumn["CHARACTER_MAXIMUM_LENGTH"].toString();
                            tableColumn.length = !_this13.isDefaultColumnLength(table, tableColumn, length) ? length : "";
                          }
                          if (tableColumn.type === "decimal" || tableColumn.type === "double" || tableColumn.type === "float") {
                            if (dbColumn["NUMERIC_PRECISION"] !== null && !_this13.isDefaultColumnPrecision(table, tableColumn, dbColumn["NUMERIC_PRECISION"])) tableColumn.precision = parseInt(dbColumn["NUMERIC_PRECISION"]);
                            if (dbColumn["NUMERIC_SCALE"] !== null && !_this13.isDefaultColumnScale(table, tableColumn, dbColumn["NUMERIC_SCALE"])) tableColumn.scale = parseInt(dbColumn["NUMERIC_SCALE"]);
                          }
                          if (tableColumn.type === "enum" || tableColumn.type === "simple-enum" || tableColumn.type === "set") {
                            var colType = dbColumn["COLUMN_TYPE"];
                            var items = colType.substring(colType.indexOf("(") + 1, colType.lastIndexOf(")")).split(",");
                            tableColumn.enum = items.map(function (item) {
                              return item.substring(1, item.length - 1);
                            });
                            tableColumn.length = "";
                          }
                          if ((tableColumn.type === "datetime" || tableColumn.type === "time" || tableColumn.type === "timestamp") && dbColumn["DATETIME_PRECISION"] !== null && dbColumn["DATETIME_PRECISION"] !== undefined && !_this13.isDefaultColumnPrecision(table, tableColumn, parseInt(dbColumn["DATETIME_PRECISION"]))) {
                            tableColumn.precision = parseInt(dbColumn["DATETIME_PRECISION"]);
                          }
                          return tableColumn;
                        });
                        // find foreign key constraints of table, group them by constraint name and build TableForeignKey.
                        tableForeignKeyConstraints = OrmUtils.uniq(dbForeignKeys.filter(function (dbForeignKey) {
                          return dbForeignKey["TABLE_NAME"] === dbTable["TABLE_NAME"] && dbForeignKey["TABLE_SCHEMA"] === dbTable["TABLE_SCHEMA"];
                        }), function (dbForeignKey) {
                          return dbForeignKey["CONSTRAINT_NAME"];
                        });
                        table.foreignKeys = tableForeignKeyConstraints.map(function (dbForeignKey) {
                          var foreignKeys = dbForeignKeys.filter(function (dbFk) {
                            return dbFk["CONSTRAINT_NAME"] === dbForeignKey["CONSTRAINT_NAME"];
                          });
                          // if referenced table located in currently used db, we don't need to concat db name to table name.
                          var database = dbForeignKey["REFERENCED_TABLE_SCHEMA"] === currentDatabase ? undefined : dbForeignKey["REFERENCED_TABLE_SCHEMA"];
                          var referencedTableName = _this13.driver.buildTableName(dbForeignKey["REFERENCED_TABLE_NAME"], undefined, database);
                          return new TableForeignKey({
                            name: dbForeignKey["CONSTRAINT_NAME"],
                            columnNames: foreignKeys.map(function (dbFk) {
                              return dbFk["COLUMN_NAME"];
                            }),
                            referencedDatabase: dbForeignKey["REFERENCED_TABLE_SCHEMA"],
                            referencedTableName: referencedTableName,
                            referencedColumnNames: foreignKeys.map(function (dbFk) {
                              return dbFk["REFERENCED_COLUMN_NAME"];
                            }),
                            onDelete: dbForeignKey["ON_DELETE"],
                            onUpdate: dbForeignKey["ON_UPDATE"]
                          });
                        });
                        // find index constraints of table, group them by constraint name and build TableIndex.
                        tableIndexConstraints = OrmUtils.uniq(dbIndices.filter(function (dbIndex) {
                          return dbIndex["TABLE_NAME"] === dbTable["TABLE_NAME"] && dbIndex["TABLE_SCHEMA"] === dbTable["TABLE_SCHEMA"];
                        }), function (dbIndex) {
                          return dbIndex["INDEX_NAME"];
                        });
                        table.indices = tableIndexConstraints.map(function (constraint) {
                          var indices = dbIndices.filter(function (index) {
                            return index["TABLE_SCHEMA"] === constraint["TABLE_SCHEMA"] && index["TABLE_NAME"] === constraint["TABLE_NAME"] && index["INDEX_NAME"] === constraint["INDEX_NAME"];
                          });
                          var nonUnique = parseInt(constraint["NON_UNIQUE"], 10);
                          return new TableIndex({
                            table: table,
                            name: constraint["INDEX_NAME"],
                            columnNames: indices.map(function (i) {
                              return i["COLUMN_NAME"];
                            }),
                            isUnique: nonUnique === 0,
                            isSpatial: constraint["INDEX_TYPE"] === "SPATIAL",
                            isFulltext: constraint["INDEX_TYPE"] === "FULLTEXT"
                          });
                        });
                        return _context57.abrupt("return", table);
                      case 13:
                      case "end":
                        return _context57.stop();
                    }
                  }, _callee57);
                }));
                return function (_x92) {
                  return _ref5.apply(this, arguments);
                };
              }())));
            case 48:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
      function loadTables(_x91) {
        return _loadTables.apply(this, arguments);
      }
      return loadTables;
    }()
    /**
     * Builds create table sql
     */
  }, {
    key: "createTableSql",
    value: function createTableSql(table, createForeignKeys) {
      var _this14 = this;
      var columnDefinitions = table.columns.map(function (column) {
        return _this14.buildCreateColumnSql(column, true);
      }).join(", ");
      var sql = "CREATE TABLE ".concat(this.escapePath(table), " (").concat(columnDefinitions);
      // we create unique indexes instead of unique constraints, because MySql does not have unique constraints.
      // if we mark column as Unique, it means that we create UNIQUE INDEX.
      table.columns.filter(function (column) {
        return column.isUnique;
      }).forEach(function (column) {
        var isUniqueIndexExist = table.indices.some(function (index) {
          return index.columnNames.length === 1 && !!index.isUnique && index.columnNames.indexOf(column.name) !== -1;
        });
        var isUniqueConstraintExist = table.uniques.some(function (unique) {
          return unique.columnNames.length === 1 && unique.columnNames.indexOf(column.name) !== -1;
        });
        if (!isUniqueIndexExist && !isUniqueConstraintExist) table.indices.push(new TableIndex({
          name: _this14.connection.namingStrategy.uniqueConstraintName(table, [column.name]),
          columnNames: [column.name],
          isUnique: true
        }));
      });
      // as MySql does not have unique constraints, we must create table indices from table uniques and mark them as unique.
      if (table.uniques.length > 0) {
        table.uniques.forEach(function (unique) {
          var uniqueExist = table.indices.some(function (index) {
            return index.name === unique.name;
          });
          if (!uniqueExist) {
            table.indices.push(new TableIndex({
              name: unique.name,
              columnNames: unique.columnNames,
              isUnique: true
            }));
          }
        });
      }
      if (table.indices.length > 0) {
        var indicesSql = table.indices.map(function (index) {
          var columnNames = index.columnNames.map(function (columnName) {
            return "`".concat(columnName, "`");
          }).join(", ");
          if (!index.name) index.name = _this14.connection.namingStrategy.indexName(table, index.columnNames, index.where);
          var indexType = "";
          if (index.isUnique) indexType += "UNIQUE ";
          if (index.isSpatial) indexType += "SPATIAL ";
          if (index.isFulltext) indexType += "FULLTEXT ";
          return "".concat(indexType, "INDEX `").concat(index.name, "` (").concat(columnNames, ")");
        }).join(", ");
        sql += ", ".concat(indicesSql);
      }
      if (table.foreignKeys.length > 0 && createForeignKeys) {
        var foreignKeysSql = table.foreignKeys.map(function (fk) {
          var columnNames = fk.columnNames.map(function (columnName) {
            return "`".concat(columnName, "`");
          }).join(", ");
          if (!fk.name) fk.name = _this14.connection.namingStrategy.foreignKeyName(table, fk.columnNames);
          var referencedColumnNames = fk.referencedColumnNames.map(function (columnName) {
            return "`".concat(columnName, "`");
          }).join(", ");
          var constraint = "CONSTRAINT `".concat(fk.name, "` FOREIGN KEY (").concat(columnNames, ") REFERENCES ").concat(_this14.escapePath(_this14.getTablePath(fk)), " (").concat(referencedColumnNames, ")");
          if (fk.onDelete) constraint += " ON DELETE ".concat(fk.onDelete);
          if (fk.onUpdate) constraint += " ON UPDATE ".concat(fk.onUpdate);
          return constraint;
        }).join(", ");
        sql += ", ".concat(foreignKeysSql);
      }
      if (table.primaryColumns.length > 0) {
        var columnNames = table.primaryColumns.map(function (column) {
          return "`".concat(column.name, "`");
        }).join(", ");
        sql += ", PRIMARY KEY (".concat(columnNames, ")");
      }
      sql += ") ENGINE=".concat(table.engine || "InnoDB");
      return new Query(sql);
    }
    /**
     * Builds drop table sql
     */
  }, {
    key: "dropTableSql",
    value: function dropTableSql(tableOrName) {
      return new Query("DROP TABLE ".concat(this.escapePath(tableOrName)));
    }
  }, {
    key: "createViewSql",
    value: function createViewSql(view) {
      if (typeof view.expression === "string") {
        return new Query("CREATE VIEW ".concat(this.escapePath(view), " AS ").concat(view.expression));
      } else {
        return new Query("CREATE VIEW ".concat(this.escapePath(view), " AS ").concat(view.expression(this.connection).getQuery()));
      }
    }
  }, {
    key: "insertViewDefinitionSql",
    value: function () {
      var _insertViewDefinitionSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59(view) {
        var currentDatabase, expression;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return this.getCurrentDatabase();
            case 2:
              currentDatabase = _context59.sent;
              expression = typeof view.expression === "string" ? view.expression.trim() : view.expression(this.connection).getQuery();
              return _context59.abrupt("return", this.insertTypeormMetadataSql({
                type: MetadataTableType.VIEW,
                schema: currentDatabase,
                name: view.name,
                value: expression
              }));
            case 5:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this);
      }));
      function insertViewDefinitionSql(_x93) {
        return _insertViewDefinitionSql.apply(this, arguments);
      }
      return insertViewDefinitionSql;
    }()
    /**
     * Builds drop view sql.
     */
  }, {
    key: "dropViewSql",
    value: function dropViewSql(viewOrPath) {
      return new Query("DROP VIEW ".concat(this.escapePath(viewOrPath)));
    }
    /**
     * Builds remove view sql.
     */
  }, {
    key: "deleteViewDefinitionSql",
    value: function () {
      var _deleteViewDefinitionSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(viewOrPath) {
        var currentDatabase, viewName;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return this.getCurrentDatabase();
            case 2:
              currentDatabase = _context60.sent;
              viewName = InstanceChecker.isView(viewOrPath) ? viewOrPath.name : viewOrPath;
              return _context60.abrupt("return", this.deleteTypeormMetadataSql({
                type: MetadataTableType.VIEW,
                schema: currentDatabase,
                name: viewName
              }));
            case 5:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this);
      }));
      function deleteViewDefinitionSql(_x94) {
        return _deleteViewDefinitionSql.apply(this, arguments);
      }
      return deleteViewDefinitionSql;
    }()
    /**
     * Builds create index sql.
     */
  }, {
    key: "createIndexSql",
    value: function createIndexSql(table, index) {
      var columns = index.columnNames.map(function (columnName) {
        return "`".concat(columnName, "`");
      }).join(", ");
      var indexType = "";
      if (index.isUnique) indexType += "UNIQUE ";
      if (index.isSpatial) indexType += "SPATIAL ";
      if (index.isFulltext) indexType += "FULLTEXT ";
      return new Query("CREATE ".concat(indexType, "INDEX `").concat(index.name, "` ON ").concat(this.escapePath(table), " (").concat(columns, ")"));
    }
    /**
     * Builds drop index sql.
     */
  }, {
    key: "dropIndexSql",
    value: function dropIndexSql(table, indexOrName) {
      var indexName = InstanceChecker.isTableIndex(indexOrName) ? indexOrName.name : indexOrName;
      return new Query("DROP INDEX `".concat(indexName, "` ON ").concat(this.escapePath(table)));
    }
    /**
     * Builds create primary key sql.
     */
  }, {
    key: "createPrimaryKeySql",
    value: function createPrimaryKeySql(table, columnNames) {
      var columnNamesString = columnNames.map(function (columnName) {
        return "`".concat(columnName, "`");
      }).join(", ");
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " ADD PRIMARY KEY (").concat(columnNamesString, ")"));
    }
    /**
     * Builds drop primary key sql.
     */
  }, {
    key: "dropPrimaryKeySql",
    value: function dropPrimaryKeySql(table) {
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP PRIMARY KEY"));
    }
    /**
     * Builds create foreign key sql.
     */
  }, {
    key: "createForeignKeySql",
    value: function createForeignKeySql(table, foreignKey) {
      var columnNames = foreignKey.columnNames.map(function (column) {
        return "`".concat(column, "`");
      }).join(", ");
      var referencedColumnNames = foreignKey.referencedColumnNames.map(function (column) {
        return "`".concat(column, "`");
      }).join(",");
      var sql = "ALTER TABLE ".concat(this.escapePath(table), " ADD CONSTRAINT `").concat(foreignKey.name, "` FOREIGN KEY (").concat(columnNames, ") ") + "REFERENCES ".concat(this.escapePath(this.getTablePath(foreignKey)), "(").concat(referencedColumnNames, ")");
      if (foreignKey.onDelete) sql += " ON DELETE ".concat(foreignKey.onDelete);
      if (foreignKey.onUpdate) sql += " ON UPDATE ".concat(foreignKey.onUpdate);
      return new Query(sql);
    }
    /**
     * Builds drop foreign key sql.
     */
  }, {
    key: "dropForeignKeySql",
    value: function dropForeignKeySql(table, foreignKeyOrName) {
      var foreignKeyName = InstanceChecker.isTableForeignKey(foreignKeyOrName) ? foreignKeyOrName.name : foreignKeyOrName;
      return new Query("ALTER TABLE ".concat(this.escapePath(table), " DROP FOREIGN KEY `").concat(foreignKeyName, "`"));
    }
    /**
     * Escapes a given comment so it's safe to include in a query.
     */
  }, {
    key: "escapeComment",
    value: function escapeComment(comment) {
      if (!comment || comment.length === 0) {
        return "''";
      }
      comment = comment.replace(/\\/g, "\\\\") // MySQL allows escaping characters via backslashes
      .replace(/'/g, "''").replace(/\u0000/g, ""); // Null bytes aren't allowed in comments
      return "'".concat(comment, "'");
    }
    /**
     * Escapes given table or view path.
     */
  }, {
    key: "escapePath",
    value: function escapePath(target) {
      var _this$driver$parseTab2 = this.driver.parseTableName(target),
        database = _this$driver$parseTab2.database,
        tableName = _this$driver$parseTab2.tableName;
      if (database && database !== this.driver.database) {
        return "`".concat(database, "`.`").concat(tableName, "`");
      }
      return "`".concat(tableName, "`");
    }
    /**
     * Builds a part of query to create/change a column.
     */
  }, {
    key: "buildCreateColumnSql",
    value: function buildCreateColumnSql(column, skipPrimary) {
      var skipName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var c = "";
      if (skipName) {
        c = this.connection.driver.createFullType(column);
      } else {
        c = "`".concat(column.name, "` ").concat(this.connection.driver.createFullType(column));
      }
      if (column.asExpression) c += " AS (".concat(column.asExpression, ") ").concat(column.generatedType ? column.generatedType : "VIRTUAL");
      // if you specify ZEROFILL for a numeric column, MySQL automatically adds the UNSIGNED attribute to that column.
      if (column.zerofill) {
        c += " ZEROFILL";
      } else if (column.unsigned) {
        c += " UNSIGNED";
      }
      if (column.enum) c += " (".concat(column.enum.map(function (value) {
        return "'" + value + "'";
      }).join(", "), ")");
      if (column.charset) c += " CHARACTER SET \"".concat(column.charset, "\"");
      if (column.collation) c += " COLLATE \"".concat(column.collation, "\"");
      if (!column.isNullable) c += " NOT NULL";
      if (column.isNullable) c += " NULL";
      if (column.isPrimary && !skipPrimary) c += " PRIMARY KEY";
      if (column.isGenerated && column.generationStrategy === "increment")
        // don't use skipPrimary here since updates can update already exist primary without auto inc.
        c += " AUTO_INCREMENT";
      if (column.comment) c += " COMMENT ".concat(this.escapeComment(column.comment));
      if (column.default !== undefined && column.default !== null) c += " DEFAULT ".concat(column.default);
      if (column.onUpdate) c += " ON UPDATE ".concat(column.onUpdate);
      return c;
    }
    /**
     * Checks if column display width is by default.
     */
  }, {
    key: "isDefaultColumnWidth",
    value: function isDefaultColumnWidth(table, column, width) {
      // if table have metadata, we check if length is specified in column metadata
      if (this.connection.hasMetadata(table.name)) {
        var metadata = this.connection.getMetadata(table.name);
        var columnMetadata = metadata.findColumnWithDatabaseName(column.name);
        if (columnMetadata && columnMetadata.width) return false;
      }
      var defaultWidthForType = this.connection.driver.dataTypeDefaults && this.connection.driver.dataTypeDefaults[column.type] && this.connection.driver.dataTypeDefaults[column.type].width;
      if (defaultWidthForType) {
        // In MariaDB & MySQL 5.7, the default widths of certain numeric types are 1 less than
        // the usual defaults when the column is unsigned.
        // This also applies to Aurora MySQL.
        var typesWithReducedUnsignedDefault = ["int", "tinyint", "smallint", "mediumint"];
        var needsAdjustment = typesWithReducedUnsignedDefault.indexOf(column.type) !== -1;
        if (column.unsigned && needsAdjustment) {
          return defaultWidthForType - 1 === width;
        } else {
          return defaultWidthForType === width;
        }
      }
      return false;
    }
  }]);
  return AuroraMysqlQueryRunner;
}(BaseQueryRunner);